import { gql } from '@apollo/client';

const GET_ME = gql`
  query getMe(
    $settingsWhere: UserSettingsWhereInput!
    $toursSettingsWhere: ToursSettingsWhereInput!
    $licensesWhere: LicensesWhereInput!
  ) {
    me {
      id
      firstName
      lastName
      avatarUrl
      licenses(where: $licensesWhere) {
        id
        dateExpiration
        expired
        licenseType
        product {
          id
          family {
            id
            code
          }
        }
      }
      dateCreated
      dateRemoved
      dateUpdated
      settings(where: $settingsWhere) {
        appId
        setting
        value
      }
      toursSettings(where: $toursSettingsWhere) {
        tourId
        tour {
          name
        }
        tourStepSettings {
          viewed
        }
      }
    }
  }
`;

export default GET_ME;
